"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateRecipeMutation = void 0;
const client_1 = require("@apollo/client");
const recipePreviewFragment_1 = require("../fragments/recipePreviewFragment");
exports.updateRecipeMutation = client_1.gql `
  mutation UpdateRecipe($id: String!, $recipe: RecipeInput!) {
    updateRecipe(id: $id, recipe: $recipe) {
      __typename
      errors {
        path
        message
      }
      uploadUrl
      recipe {
        ...RecipePreview
      }
    }
  }
  ${recipePreviewFragment_1.recipePreviewFragment}
`;
//# sourceMappingURL=UpdateRecipe.js.map